import BaseObject from './BaseObject.js';

export default class TertiaryMenuItem extends BaseObject {
  constructor(id, component, props) {
    super();
    this.id = id;
    this.features = [];

    this.primary = '';
    this.secondary = '';

    this.component = component;
    this.props = props;
  }

  get path() {
    return `/${this.primary}/${this.secondary}/${this.id}`;
  }

  get route() {
    if ((this.component || null) === null) {
      return null;
    }
    return {
      path: this.path,
      name: this.id,
      component: this.component,
      props: this.props,
      meta: {
        verifyAuth: true,
        primary: this.primary,
        secondary: this.secondary,
        tertiary: this.id,
        title: this.id
      }
    };
  }

  /**
 * 被註冊到 SecondaryMenuItem
 * @param {SecondaryMenuItem} secondary SecondaryMenuItem
 */
  Registered(secondary) {
    this.primary = secondary.primary;
    this.secondary = secondary.id;
  }

  ClearChildren() {
    this.features = [];
  }
}
